import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { CategoryAirPlaySecurityConfigurationService } from '@rocksoft/settings-sdk';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { CategoryResolvedConfigurationResolverActions } from '../category-resolved-configuration/category-resolved-configuration.actions';
import { safeMap } from '../effects.helpers';
import {
  CategoryAirplaySecurityProfilePresetConfigurationApiActions,
  CategoryAirplaySecurityProfilePresetConfigurationViewActions,
} from './category-airplay-security-profile-preset-configuration.actions';

@Injectable()
export class CategoryAirplaySecurityProfilePresetConfigurationEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryAirplaySecurityConfigurationService = inject(CategoryAirPlaySecurityConfigurationService);

  linkAirplaySecurityProfileToCategoryEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(CategoryAirplaySecurityProfilePresetConfigurationViewActions.profilePresetConfigurationSelected),
      mergeMap((action) => {
        const categoryType = action.category.categoryType;
        const category = action.category;

        return safeMap(
          this.categoryAirplaySecurityConfigurationService.addAirPlaySecurityProfileToCategory({
            categoryType,
            categoryId: category.categoryId,
            addAirPlaySecurityProfileToCategoryCommand: {
              airPlaySecurityProfilePresetId: action.preset.uniqueId,
            },
          }),
          () =>
            CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
              categoryId: category.categoryId,
            }),
          (error) =>
            CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationUpdatedError({
              category,
              error,
            })
        );
      })
    );
  });

  deleteLinkedAirplaySecurityProfileFromCategoryEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(CategoryAirplaySecurityProfilePresetConfigurationViewActions.profilePresetConfigurationDeselected),
      mergeMap((action) => {
        const category = action.category;
        const categoryType = category.categoryType;

        return safeMap(
          this.categoryAirplaySecurityConfigurationService.deleteAirPlaySecurityProfileFromCategory({
            categoryType,
            categoryId: category.categoryId,
          }),
          () =>
            CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
              categoryId: category.categoryId,
            }),
          (error) =>
            CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationUpdatedError({
              category,
              error,
            })
        );
      })
    );
  });

  categoryAirplaySecurityProfileUpdatedErrorEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        CategoryAirplaySecurityProfilePresetConfigurationApiActions.categoryProfilePresetConfigurationUpdatedError
      ),
      map((action) =>
        CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested({
          categoryId: action.category.categoryId,
        })
      )
    );
  });
}
